import React from "react";

import moment from "moment";
import { View, Text, ScrollView } from "react-native";

import { amountAsCurrency } from "../../../../services/currency";
import { tailwind } from "../../../../tailwind";
import { Currency } from "../../../../types/Payment";
import { PaymentPlanType, Price } from "../../../../types/Product";

export type Props = {
  currency: Currency;
  price: Price;
  showFirstPaymentDate?: boolean;
};

const PaymentDates = ({
  price,
  currency,
  showFirstPaymentDate = true,
}: Props) => {
  const getDatesFromPrice = (price: Price) => {
    // gets dates from price.installments
    // and returns array with formated dates
    moment.locale("es");
    const dates = price.installments.map((x) =>
      moment(x).format("DD-MMM-YYYY")
    );
    return dates;
  };

  const dates = getDatesFromPrice(price);
  const singleInstallmentAmount =
    price.payment_plan_type === PaymentPlanType.INSTALLMENT
      ? price.amount / price.installments_count
      : price.amount;

  return (
    <ScrollView style={tailwind("max-h-32")}>
      <View style={tailwind("flex flex-col pt-1.5")}>
        {dates.map((date, index) => {
          return index === 0 ? (
            showFirstPaymentDate && (
              <View
                key={index}
                style={tailwind(
                  "flex flex-row justify-between bg-cuanto-100 mx-3 rounded"
                )}
              >
                <Text
                  style={tailwind(" pr-2 rounded text-xs font-semibold p-2")}
                >
                  {`Pago #${index + 1}`}
                </Text>
                <Text style={tailwind(" pr-2 rounded text-xs font-bold p-2")}>
                  {amountAsCurrency({
                    amount: singleInstallmentAmount,
                    currency,
                  })}
                </Text>
              </View>
            )
          ) : (
            <View
              key={index}
              style={tailwind("flex flex-row justify-between mx-3")}
            >
              <Text style={tailwind(" pr-2 rounded text-xs p-2")}>
                {`Pago #${index + 1}`}
              </Text>
              <Text style={tailwind(" pr-2 rounded text-xs text-gray-500 p-2")}>
                {date}
              </Text>
            </View>
          );
        })}
      </View>
    </ScrollView>
  );
};

export default PaymentDates;
